<template>
    <div class="loadingwrap"> 
		<div class="mask">
			<!-- <div class="tips">
				<div class="tipsTitle">{{$t('loading.tipsTitle')}}</div>
				<template v-if="sessionStorage.isWebKit=='1'">
					<div class="tipsText">{{$t('loading.tipsText1')}}</div> 
				</template>
				<template v-else>
					<div class="tipsText">{{$t('loading.tipsText0')}}</div> 
				</template>
			</div> -->
			<div class="loading_bj">
				<div class="circleBox">
					<div class="progressBox">
						<img class="progress" :style="{right:progress+'%'}" src="../assets/img/loading_Progress.png" alt="">
					</div>
					<img class="loading_circle" :style="{right:progress+'%'}" src="../assets/img/loading_cicle.png" alt="">     
				</div>        
			</div>    
			<div class="loadingText">{{$t('loading.load')}}<span class="dot">{{dot}}</span></div>
		</div>
        <div class="logo"></div>
  	</div>
</template>
<script>
	export default {
		data(){
			return{
				progress:95,
				dot:'...'
			}
		},
		mounted:function(){
			this.timerStart();
			var that=this;
			setInterval(function(){
				if(that.dot=='.'){
					that.dot='..';
				}else if(that.dot=='..'){
					that.dot='...'
				}else{
					that.dot='.'
				}
			},1000);
		},
		methods:{
			timerStart(){
				const that=this;
				var timer=setInterval(function(){
					if(that.progress>5){
						that.progress-=1;
					}else{
						clearInterval(timer);
					}
				},60);
			}
		},
	}
</script>

<style scoped>
    .loadingwrap{  
		height: 100%;
		background: url('../assets/img/start_bj.png') no-repeat ;
		background-size: cover;
		position: relative;
		overflow: hidden;
    } 
	.mask{
		background-color: rgba(0, 0, 0, .6);
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
	}
    .tips{
		background: url('../assets/img/tips.png') no-repeat;
		background-size: cover;
		width: 598px;
		height: 326px;
		margin:178px auto 0;
    }
    .tipsTitle{
    	width: 598px;
    	text-align: center;
		color: #AA723C;
		font-size: 80px;
		text-shadow:5px 0px 6px #fff,
					0px 5px 6px #fff;
    }
    .tipsText{
    	width: 480px;
		color: #AA723C;
		font-size: 32px;
		padding-top: 10px;
		padding-left: 57px;
    }

    /*进度条背景*/
    .loading_bj{
		background: url('../assets/img/loading_bj.png') no-repeat;
		background-size: cover;
		width: 700px;
		height: 104px;
		margin:500px auto 0;
		position: relative;
    }
    /*进度条*/  
    .circleBox{
		width:640px;
		height: 20px;
		background: url('../assets/img/Loadingbar.png') no-repeat;
		background-size: cover;
		position: absolute;
		left: 30px;
		bottom: 17px;
		border-radius: 10px;
    }
    .progressBox{
		width:640px;
		height: 20px;
		position: absolute;
		border-radius: 10px;
		overflow: hidden;
    }
    .progress{
    	width: 640px;
    	height: 20px;
    	position: absolute;
    	right: 96%;
    }
  	.loading_circle{
		width: 40px;
		height: 40px;
		position: absolute;
		right: 96%;
		top: -8px;
    }

    /*loading文字*/
    .loadingText{
		font-size: 60px;
		color: #AA723C;
		text-align: center;
		margin-top: 59px;
  	}
  	.logo{
        width: 180px;
        height: 120px;
        position: fixed;
        left: 20px;
        top: 20px;
        background: url('../assets/img/logo.png') no-repeat;
        background-size: 100% 100%;
    }
    .dot{
    	width: 30px;
    	display: inline-block;
    	text-align: left;
    }
	

</style>




// WEBPACK FOOTER //
// src/components/Loading.vue